import type { Group, GroupId } from 'types/group'
import type { ShareableChannelData } from 'types/shareable-channel'
import * as types from './types'
export const loadGroupContents = (
  group: Group,
): {
  group: Group
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS,
  group,
})
export const loadGroupContentsSuccess = (
  group: Group | ShareableChannelData,
  response: any,
): {
  group: Group | ShareableChannelData
  response: any
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_SUCCESS,
  group,
  response,
})
export const loadGroupContentsFail = (
  group: Group,
  error: Error,
): {
  error: Error
  group: Group
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_FAIL,
  group,
  error,
})
export const loadGroupContentsNext = (
  groupId: GroupId,
): {
  groupId: GroupId
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_NEXT,
  groupId,
})
export const loadGroupContentsNextSuccess = (
  groupId: GroupId,
  response: any,
): {
  groupId: GroupId
  response: any
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_NEXT_SUCCESS,
  groupId,
  response,
})
export const loadGroupContentsNextFail = (
  groupId: GroupId,
  error: Error,
): {
  error: Error
  groupId: GroupId
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_NEXT_FAIL,
  groupId,
  error,
})
